import styled from "styled-components";

export const Container = styled.div`
  background-color: ${props => props.theme.colors.inputBackground};
  display: flex;
  gap: 4px;
  padding: 6px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const Options = styled.div<{open: boolean}>`
  display: flex;
  opacity: ${props => props.open ? 1 : 0};
  align-items: center;
  justify-content: center;
  padding: 4px;
  gap: 4px;
  border-radius: 4px;
  background-color: ${props => props.theme.colors.inputBackground};
  position: absolute;
  top: 108%;
  left: 0;

  transition: all 0.5s;
`;

export const IconContainer = styled.div<{selected: boolean}>`
  background-color: ${props => props.selected ? props.theme.colors.white : 'transparent'};
  opacity: ${props => props.selected ? 1 : 0.7};
  border-radius: 2px;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  
  transition: all 0.5s;

  &:hover{
    cursor: pointer;
  }

  &:active {
    background-color: ${props => props.theme.colors.border};
  }
`;

export const SelectedIcon = styled.div`
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  transition: all 0.5s;

  &:hover{
    cursor: pointer;
  }

  .opened {
    transform: rotate(180deg);
  }
  
  .closed {
    transform: rotate(0deg);
  }
`;